import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { handleSaveWidgetSettings, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { BlockStack, Box, InlineGrid, RangeSlider } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const WidgetFontSize = () => {
  const { t } = useTranslation('widget_settings');

  const widgetSettings = useSelector(widgetSettingSelector);
  const dispatch = useDispatch();

  return (
    <BlockStack gap={'300'}>
      <BoldText>{t('widgetDesign.textField.fontSize.title')}</BoldText>
      <InlineGrid gap={'1000'} columns={{ sm: 1, md: 2 }}>
        <Box>
          <RangeSlider
            label={t('widgetDesign.colour.heading.headerFontSize')}
            value={widgetSettings.sizes.headingFontSize}
            suffix={<RegularText fontWeight="medium">{`${widgetSettings.sizes.headingFontSize}px`}</RegularText>}
            step={1}
            min={1}
            max={64}
            onChange={(fontSize) =>
              dispatch(
                handleSaveWidgetSettings({
                  sizes: {
                    ...widgetSettings.sizes,
                    headingFontSize: fontSize ? Number(fontSize) : 0,
                  },
                }),
              )
            }
          />
        </Box>
        <Box>
          <RangeSlider
            label={t('widgetDesign.colour.message.label')}
            value={widgetSettings.sizes.errorMessageFontSize}
            suffix={<RegularText fontWeight="medium">{`${widgetSettings.sizes.errorMessageFontSize}px`}</RegularText>}
            step={1}
            min={1}
            max={64}
            onChange={(fontSize) =>
              dispatch(
                handleSaveWidgetSettings({
                  sizes: {
                    ...widgetSettings.sizes,
                    errorMessageFontSize: fontSize ? Number(fontSize) : 0,
                  },
                }),
              )
            }
          />
        </Box>
      </InlineGrid>
    </BlockStack>
  );
};
